<template>
  <el-dialog
    :title="$t('attendanceRecord.view')"
    :visible.sync="verifyPhotoDia"
    width="30%"
  >
    <div style="text-align:center">
      <el-image :src="verifyPhoto">
        <div slot="placeholder" class="image-slot">
          {{ $t('common.loading') }}<span class="dot">...</span>
        </div>
      </el-image>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="verifyPhotoDia = false">{{
        $t('common.yes')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'verifyPhoto',
  data() {
    return {
      verifyPhotoDia: false,
      verifyPhoto: ''
    }
  },
  methods: {
    showPhotoDia(url) {
      if (!url) {
        this.errorMessage(this.$t('common.noPhoto'))
        return false
      }
      this.verifyPhoto = url
      this.verifyPhotoDia = true
    },
    closeDia() {
      this.verifyPhotoDia = false
      this.verifyPhoto = ''
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/modules/comComponent/verifyPhoto.vue